// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"Ue-z","flipped":"Ve-z","mainContentContainer":"We-z","cta":"Xe-z","mainContentCtaDefault":"Ye-z","disabled":"Ze-z","mainContentCtaWhite":"_e-z"};